// pages/Dashboard.jsx
import Contact from "../components/contactComponents/Contact";
import HomeLayout from "../components/HomeLayout";

export default function ContactPage() {
  return (
    <HomeLayout>
      <Contact />
    </HomeLayout>
  );
}
